<!-- Freemium usage banner -->
<div class="license-banner banner--freemium"
     [class.banner--limit]="isLimitReached"
     @slideDown
     *ngIf="isFreemium && isVisible && !isDismissed">
  <div class="banner-content banner-content--center">
    <div class="freemium-info">
      <span class="banner-text">{{ freemiumText }}</span>
      <div class="usage-bar" *ngIf="meetingLimit !== null" aria-hidden="true">
        <span class="usage-bar__fill" [style.width.%]="usagePercent"></span>
      </div>
    </div>
    <button type="button" class="banner-cta-pill" (click)="openContactUs()">Talk to Sales</button>
  </div>
</div>

<!-- License expiry / grace banner -->
<div class="license-banner"
     [class.banner--grace]="isGrace"
     @slideDown
     *ngIf="!isFreemium && isVisible && !isDismissed">
  <div class="banner-content">
    <span class="banner-icon">{{ isGrace ? '🔴' : '⚠️' }}</span>
    <span class="banner-text">{{ bannerText }}</span>
    <a class="banner-cta" (click)="openContactUs()">Keep Convverse →</a>
  </div>
  <button class="banner-dismiss" (click)="dismiss()" aria-label="Dismiss">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>
  </button>
</div>
